/* ============
 * Organization Type Transformer
 * ============
 *
 * The transformer for the organization type.
 */

import Transformer from './transformer';

export default class OrganizationTypeTransformer extends Transformer {
  static fetch(organizationType) {
    return {
      id: organizationType.id,
      name: organizationType.name,
    };
  }

  static send(organizationType) {
    return {
      id: organizationType.id,
      name: organizationType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/organizationType.js